import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { AdminContractsRoutingModule } from './contracts-routing.module';
import { AdminContractListComponent } from './contract-list/contract-list.component';
import { ContractsModule } from '../../my-contracts/contracts.module';

@NgModule({
  imports: [
    CommonModule,
    AdminContractsRoutingModule,
    ContractsModule,
    InputsModule,
    DropDownsModule,
    FormsModule,
    NgbModule,
    TranslateModule.forChild(),
    ComponentsModule,
    PipeModule,
    DateInputsModule,
  ],
  declarations: [AdminContractListComponent],
})
export class AdminContractsModule {}
